import Rings from './Rings';

export default Rings;
